import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaTipoFormacion from "../vistas/vista_tipo_formacion";
import FormTipoFormacion from "../formularios/form_tipo_formacion";

export default class DesplegableTipoFormacion extends Component {
  render() {
    return (
      <Desplegable
        eventKey="1"
        id="1"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[1]}
        boton="Añadir"
        Toogle={"Tipo de formación"}
        Text={
          <VistaTipoFormacion
            DatosUsuario={this.props.state.DatosUsuario}
            showModalTipoFormacionArray={this.props.state.showModalMatrix[2]}
            handleButtonShow={this.props.handleButtonShow}
            setTipoFormacion={this.props.setTipoFormacion}
            putTipoFormacion={this.props.putTipoFormacion}
            deleteTipoFormacion={this.props.deleteTipoFormacion}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          />
        }
        Form={
          <FormTipoFormacion
            DatosUsuario={this.props.state.DatosUsuario}
            handleButtonShow={this.props.handleButtonShow}
            setTipoFormacion={this.props.setTipoFormacion}
            putTipoFormacion={this.props.putTipoFormacion}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          />
        }
        canEdit={true}
      />
    );
  }
}
